import { getLangFromPath } from '@/lib/i18nRouting';

type AuthOrigin = 'blog' | 'app';

const RETURN_TO_KEY = 'auth:returnTo';
const ORIGIN_KEY = 'auth:origin';
const BLOG_PATH_PATTERN = /^\/(en|es|pt)\/blog(\/|$)/;

const normalizePath = (value: string) => (value.startsWith('/') ? value : `/${value}`);

export const saveAuthReturnContext = (pathname: string, search = '') => {
  if (typeof window === 'undefined') return;
  const safePath = normalizePath(pathname || '/');
  const safeSearch = search ? (search.startsWith('?') ? search : `?${search}`) : '';
  const returnTo = `${safePath}${safeSearch}`;
  const origin: AuthOrigin = BLOG_PATH_PATTERN.test(safePath) ? 'blog' : 'app';

  window.sessionStorage.setItem(RETURN_TO_KEY, returnTo);
  window.sessionStorage.setItem(ORIGIN_KEY, origin);
};

export const resolvePostLoginDestination = (fallbackPath = '/'): string => {
  if (typeof window === 'undefined') return fallbackPath;

  const returnTo = window.sessionStorage.getItem(RETURN_TO_KEY);
  const origin = window.sessionStorage.getItem(ORIGIN_KEY) as AuthOrigin | null;
  const effectivePath = returnTo ?? fallbackPath;
  const lang = getLangFromPath(effectivePath);

  window.sessionStorage.removeItem(RETURN_TO_KEY);
  window.sessionStorage.removeItem(ORIGIN_KEY);

  if (origin === 'blog') {
    return `/${lang}/?tab=instructions`;
  }

  return returnTo ?? `/${lang}/`;
};

